export const EXAM_TYPES = Object.freeze({
    GMAT: 'gmat',
    GRE: 'gre',
    IELTS: 'ielts',
    TOEFL: 'toefl'
});
